import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { assertUnreachable } from '@dreryk/react-common';

import { RecurrencePeriod } from '../schedule/common/common.types';

export const filterPractitionersWithMedicalLicenceNumber = (practitioners: DoctorSimple[]): DoctorSimple[] =>
   practitioners.filter((practitioner) => practitioner.medicalLicenceNumber);

export const isQueryLoading = (...queries: UseCqrsQueryResult<any>[]): boolean =>
   queries.some((query) => query.loading);

export const isQueryFailed = (...queries: UseCqrsQueryResult<any>[]): boolean => queries.some((query) => query.error);

export const getRecurrencePeriodInWeeks = (recurrencePeriod: RecurrencePeriod): number => {
   switch (recurrencePeriod) {
      case RecurrencePeriod.NONE:
         return 0;
      case RecurrencePeriod.EVERY_WEEK:
         return 1;
      case RecurrencePeriod.EVERY_TWO_WEEKS:
         return 2;
      default:
         return assertUnreachable(recurrencePeriod);
   }
};
